import apiClient from "../../api/api";


/**
 * Retrieves all system roles available in the system.
 *
 * @async
 * @function getAllSystemRolesRequest
 * @returns {Promise<Array<Object>>} List of system roles returned by the API.
 *
 * @example
 * const roles = await getAllSystemRolesRequest();
 */
export const getAllSystemRolesRequest = async() => {
    const getAllSystemRolesResponse = await apiClient.get(import.meta.env.VITE_BASE_SYSTEM_ROLE_URL)
    
    return getAllSystemRolesResponse.data
}

/**
 * Retrieves a specific system role by its unique identifier.
 *
 * @async
 * @function getSystemRoleRequest
 * @param {number|string} roleId - Unique identifier of the system role.
 * @returns {Promise<Object>} System role data returned by the API.
 *
 * @example
 * const role = await getSystemRoleRequest(3);
 */
export const getSystemRoleRequest = async(roleId) => {
    const getSystemRoleResponse = await apiClient.get(import.meta.env.VITE_BASE_SYSTEM_ROLE_URL+`/${roleId}`)
    
    return getSystemRoleResponse.data
}

export const getRoleGrants = async() => {
    const getRoleGrantsResponse = await apiClient.get("/system-roles/grants?page=1&limit=1000") 

    return getRoleGrantsResponse.data
}